import React, { useRef } from 'react';
import { useSharedValue } from 'react-native-reanimated';

import type { BottomSheetRef } from '@/components/_shared/BottomSheet';
import { ViewOrderBar } from '@/components/_shared/ViewOrderBar';
import { ViewOrderBottomSheet } from '@/components/booking/ViewOrderBottomSheet';

import type { CategoryOrderSummaryProps } from './types';

/**
 * The order bar of the category list screens and the order sheet it opens.
 * The bar is absolutely positioned, so the list above needs bottom padding.
 */
export function CategoryOrderSummary({
  testID = 'category-order-bar',
  shop,
  cart,
  selectedServicesCount,
  isUpdatingCart = false,
  onAddAppointment,
}: CategoryOrderSummaryProps) {
  const sheetRef = useRef<BottomSheetRef>(null);
  const sheetIndex = useSharedValue(-1);

  const handleAddAppointment = () => {
    sheetRef.current?.close();
    onAddAppointment();
  };

  return (
    <>
      <ViewOrderBar
        testID={testID}
        isCreatingCart={isUpdatingCart}
        selectedServicesCount={selectedServicesCount}
        cart={cart}
        shop={shop}
        sheetIndex={sheetIndex}
        onPress={() => sheetRef.current?.open()}
      />
      <ViewOrderBottomSheet
        ref={sheetRef}
        cart={cart}
        shop={shop}
        isCreatingCart={isUpdatingCart}
        onAddAppointment={handleAddAppointment}
        animatedIndex={sheetIndex}
      />
    </>
  );
}
